import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function DecimalAnswer({
  identifier, pages, info, handleDeleteQuestion,
  mode, handleDuplicateQuestion, setPages,
}) {
  const question = useQuestionForm({
    identifier, pages, info, setPages, writeVia: 'setPages',
  });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.decimalAnswerText.title"
      descriptionKey="task.taskEdition.decimalAnswerText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default DecimalAnswer;
